import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EngagementFYEHdrContainerModel } from '../../../../../../models/aggregates/erp/engagement';
import { BaseApiTemplateService, Core2Config } from '../../shared';

@Injectable({
  providedIn: 'root'
})
export class EngagementFYEHdrService extends BaseApiTemplateService<EngagementFYEHdrContainerModel> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX + Core2Config.ENGAGEMENT_PREFIX + 'fye-hdrs/backoffice-ep';
    this.endpoint_path =  Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX + Core2Config.ENGAGEMENT_PREFIX + 'fye-hdrs/backoffice-ep'; 
    this.httpClient = http;
  }
}
